/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
declare const _AuthorBadgesContainer_comment$ref: unique symbol;
export type AuthorBadgesContainer_comment$ref = typeof _AuthorBadgesContainer_comment$ref;
export type AuthorBadgesContainer_comment = {
    readonly author: {
        readonly badges: ReadonlyArray<string> | null;
    } | null;
    readonly " $refType": AuthorBadgesContainer_comment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "AuthorBadgesContainer_comment",
    "type": "Comment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "author",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "badges",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'e6b7f71d032c1c1113f1e65170ca9ddf';
export default node;
